<template>
  <div>
    <van-nav-bar
    title="查询"
  />
  <div class="home">
      <Head :logo='logo'></Head>
        <van-form>
          <van-field
            v-model="idCard"
            label="证件号码"
            label-class='formTitle'
            placeholder="请输入证件号码"
          />
          <van-field
            v-model="phone"
            label="手机号码"
            label-class='formTitle'
            placeholder="请输入手机号码"
          />
          <van-field
            v-model="paymentUnit"
            label="姓名"
            label-class='formTitle'
            placeholder="请输入姓名"
          />
      </van-form>
      <van-button round block type="info" native-type="submit" @click="search" class="btn">查询</van-button>
      <Foot  v-if='list && list.bottomMessage && list.bottomMessage.length>0' :list='list'></Foot>
  </div>
  </div>
</template>

<script>
import Head from '@/components/head'
import Foot from '@/components/foot'
import { Dialog } from 'vant';
export default {
  name: 'Home',
  components: {
    Head,
    Foot
  },
  data() {
    return {
        logo:'',
        vde:'',
        idCard:'',
        paymentUnit:'',
        phone:'',
        type:0,
        list:[],
    }
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = ''
    }else {
      this.vde = this.$route.query.vde
    }
    this.logo=sessionStorage.getItem('logoImg')
     this.list=JSON.parse(sessionStorage.getItem('footList'))
  },
  methods: {
    search(){
		if(this.idCard=='' && this.paymentUnit=='' && this.phone=='' && this.type==0) {
          Dialog.alert({
            title: '提示',
            message: '至少输入一个查询条件',
          }).then(() => {
          });

        }else if(this.phone && !(/^1\d{10}$/.test(this.phone))){ 
            Dialog.alert({
              title: '提示',
              message: '手机号码格式不正确',
            }).then(() => {
            });
		}else if (this.paymentUnit && this.phone=='' && this.idCard=='') {
          Dialog.alert({
            title: '提示',
            message: '您只输入了缴款人“姓名”查询，防止查询结果错误，请再输入一个查询条件',
          }).then(() => {
            
            })
		}else  {
            this.$router.push({path:'/payList?idCard='+this.idCard+'&paymentUnit='+this.paymentUnit+'&phone='+this.phone+'&type='+this.type+'&vde='+this.vde})
        }
    },
      
  }
}
</script>


<style lang="scss" scoped>
    .home {
      background:rgba(247,247,247,1);
      padding: 0 2vw;
      box-sizing: border-box;
      margin-top: 10px;
      .van-form {
          background:rgba(255,255,255,1);
          box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
          border-radius:5px;
      }
      .van-cell {
          background: transparent;
      }
       .formTitle {
         padding-right: 40px;
          text-align-last: justify;
      } 
      .btn {
        margin-top: 30px;
      }

    }
</style>